<template>
  <div class="animated fadeIn">
    <div class="card card-green">
      <div class="card-body">
        <div class="row mb-2">
            <div class="col-2">
                <b-form-select :options="status" v-model="workingGroupStatus" value-field="value" text-field="text"></b-form-select>
            </div>
            <div class="col-2">
                <b-form-input :placeholder="$t('SEARCHBYYEAR')" v-model="searchQuerry" type="number" ></b-form-input>
            </div>
          <div class="col-8">
            <button type="button" class="btn btn-primary button-add pull-right"
              @click="showModal()">{{ $t('NEW') }}</button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12  table-responsive">
            <table class="table table-bordered table-striped table-hover table-sm table-logoped">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    {{ $t('NAME') }}
                  </th>
                  <th>
                    {{ $t('NUMBEROFCHILDRENINGROUP') }}
                  </th>
                    <th>
                        {{ $t('YEAR') }}
                    </th>
                  <th>{{ $t('ACTION') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in response.root">
                  <tr :key="item.workingGroupId" aria-rowindex="1" class=" table-ellipsis">
                    <td>
                      <icon v-if="item.isExpanded === false" @click="item.isExpanded = true" icon="plus"
                        class="hover-mouse"></icon>
                      <icon v-if="item.isExpanded === true" @click="item.isExpanded = false" icon="minus"
                        class="hover-mouse"></icon>
                    </td>
                    <td>
                      <router-link :to="'/workinggroup/workinggroupevent/' + item.workingGroupId">
                        {{ item.name }}
                      </router-link>
                    </td>
                    <td>{{ item.numberOfChildren }}</td><td>{{ item.year }}</td>
                    <td>
                      <button type="button" class="btn button-edit mr-2"
                        @click="showChildModal(item)">{{ $t('ADDCHILDRENTOGROUP') }}</button>
                      <button type="button" class="btn button-edit mr-2" @click="showModal(item)">{{ $t('EDIT') }}</button>
                      <button type="button" class="btn button-edit mr-2"
                        @click="showEvents(item.workingGroupId)">{{ $t('GOTOEVENTS') }}</button>
                      <button type="button" class="btn button-dlt"
                        @click="deleteRow(item.workingGroupId)">{{ $t('DELETE') }}</button>
                    </td>
                  </tr>
                  <tr v-if="item.isExpanded === true" :key="`${item.workingGroupId}_sec`" class=" table-ellipsis">
                    <td></td>
                    <td v-html="item.description" colspan="3"></td>
                  </tr>
                </template>
              </tbody>
            </table>
            <nav>
              <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData">
              </pagination>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <WorkingGroupForm v-model="formData" v-on:close="formData = null; getData()" />
    <WorkingGroupChildForm v-model="formDataChild" v-on:close="formDataChild = null; getData()" />
  </div>
</template>

<script>
import Api from '@/api/working_group/WorkingGroup';
import WorkingGroupForm from './WorkingGroupForm.vue';
import WorkingGroupChildForm from './WorkingGroupChildForm.vue';

export default
  {
    name: 'WorkingGroupWin',
    components:
    {
      WorkingGroupForm,
      WorkingGroupChildForm
    },
    data() {
        const me = this;
      return {
        response:
          {},
          searchQuerry: '',
        formData: null,
        formDataChild: null,
          workingGroupStatus: 'active',
        pagination:
        {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
        },
          status:
              [
                  {
                      value: 'active',
                      text: me.$i18n.t('ACTIVE'),
                  },
                  {
                      value: 'inactive',
                      text: me.$i18n.t('INACTIVE'),
                  },
              ],
      };
    },
    created() {
      const me = this;
      me.getData();
    },
    methods:
    {
      showEvents(id) {
        const me = this;
        me.$router.push(
          {
            path: `/workinggroup/workinggroupevent/${id}`,
          },
        );
      },
      async getData() {
        const me = this;
        try {
          const data = await Api.selectRow(me.getParams);
          if (data.error && data.error === true) {
            me.$notify.notice(data);
            me.loading = false;
            return;
          }

          for (const item of data.root) {
            item.isExpanded = false;
          }

          me.response = data;
        }
        catch (e) {
          me.$notify.notice(e);
        }
      },
      async deleteRow(id) {
        const me = this;
        try {
          me.$store.commit('setModalAlert',
            {
              text: me.$i18n.t('AREYOUSHURE'),
              async btnAction() {
                const data = await Api.deleteRow(
                  {
                    id,
                  },
                );
                me.$notify.notice(data);
                await me.getData();
              },
            });
        }
        catch (e) {
          me.$notify.notice(e);
        }
      },
      showModal(item) {
        const me = this;
        let data = {};
        if (typeof item !== 'undefined') {
          data = { ...item };
        }

        me.formData = data;
      },
      showChildModal(item) {
        const me = this;
        let data = {};
        if (typeof item !== 'undefined') {
          data = { ...item };
        }

        me.formDataChild = data;
      },
    },
    watch:
    {
      'pagination.limit'() {
        const me = this;
        me.getData();
      },
      'pagination.currentPage'() {
        const me = this;
        me.getData();
      },
      'pagination.query'() {
        const me = this;

        if (me.pagination.searchTimeout !== false) {
          clearTimeout(me.pagination.searchTimeout);
        }

        me.pagination.searchTimeout = setTimeout(() => {
          me.getData();
          me.pagination.searchTimeout = false;
        }, 300);
      },
        searchQuerry()
        {
            const me = this;

            if (me.searchTimeout !== false)
            {
                clearTimeout(me.searchTimeout);
            }

            me.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.searchTimeout = false;
            }, 300);
        },
        workingGroupStatus()
        {
            const me = this;
            me.getData();
        },
    },
    computed:
    {
      getParams() {
        const me = this;
        const data = {
          ...me.pagination,
        };
        data.userId = 0;
        data.status = me.workingGroupStatus;
        data.searchQuerry = me.searchQuerry;
        data.start = (data.currentPage - 1) * data.limit;
        return data;
      },
    },
  };
</script>
